// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionBox_section__1aeDT","sectionHeader":"SectionBox_sectionHeader__1xcYY","title":"SectionBox_title__14juO","sectionActions":"SectionBox_sectionActions__3Y76U"};